import { jsx as _jsx } from "react/jsx-runtime";
import { useWatchForm } from "@madmedical/form";
import { useEffect, useState } from "react";
import useResponsive from "../../../util/useResponsive";
import Button from "../../../atoms/Button";
const PreOpNextButton = ({ isDisabled, isSubmitting = false, onPress, label, validate, }) => {
    const { isSmallScreen } = useResponsive();
    const values = useWatchForm();
    const [isValid, setValid] = useState(!validate);
    useEffect(() => {
        if (!validate) {
            return;
        }
        setValid(validate(values));
    }, [values, validate]);
    return (_jsx(Button, Object.assign({ size: "md", isDisabled: isDisabled || !isValid, isLoading: isSubmitting, isLoadingText: `${label}…`, onPress: onPress, flex: isSmallScreen ? 1 : "unset" }, { children: label })));
};
export default PreOpNextButton;
